import { render, staticRenderFns } from "./ciicWeb.vue?vue&type=template&id=32b90ce2&scoped=true&"
import script from "./ciicWeb.vue?vue&type=script&lang=js&"
export * from "./ciicWeb.vue?vue&type=script&lang=js&"
import style0 from "./ciicWeb.vue?vue&type=style&index=0&id=32b90ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b90ce2",
  null
  
)

export default component.exports